export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            黑料精选
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精选的优质黑料内容，每日更新不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20article%20card%20image%2C%20abstract%20composition%20with%20crimson%20and%20dark%20tones%2C%20modern%20editorial%20design%20aesthetic%2C%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20professional%20composition%20with%20subtle%20texture&width=640&height=480&seq=card-01&orientation=landscape"
                alt="顶流男星绯闻深度解析"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                重磅
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                顶流男星绯闻深度解析：娱乐圈恋情的真相与套路
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>2小时前</span>
                <span>·</span>
                <span>128万阅读</span>
              </div>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20for%20entertainment%20gossip%20article%2C%20dark%20moody%20background%20with%20red%20accents%2C%20film%20set%20atmosphere%20abstract%20representation%2C%20cinematic%20lighting%2C%20modern%20media%20design%20aesthetic&width=640&height=480&seq=card-02&orientation=landscape"
                alt="导演新片黑料大揭秘"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                独家
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                知名导演新片黑料大揭秘：剧组内部到底发生了什么
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>5小时前</span>
                <span>·</span>
                <span>96万阅读</span>
              </div>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20television%20studio%20abstract%20scene%2C%20dark%20background%20with%20warm%20gold%20and%20red%20lighting%2C%20entertainment%20show%20atmosphere%2C%20modern%20editorial%20photography%20style%2C%20high%20contrast%20composition&width=640&height=480&seq=card-03&orientation=landscape"
                alt="综艺节目意外翻车事件"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                热议
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                综艺节目意外翻车：那些被镜头记录下的尴尬瞬间
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>8小时前</span>
                <span>·</span>
                <span>85万阅读</span>
              </div>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Digital%20social%20media%20influencer%20abstract%20scene%2C%20dark%20dramatic%20background%20with%20crimson%20glitch%20effects%2C%20modern%20online%20culture%20aesthetic%2C%20editorial%20photography%20style%2C%20warm%20moody%20lighting&width=640&height=480&seq=card-04&orientation=landscape"
                alt="网红带货翻车全记录"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-secondary-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                追踪
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                网红带货翻车全记录：品牌方索赔背后的人设崩塌
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>12小时前</span>
                <span>·</span>
                <span>72万阅读</span>
              </div>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mysterious%20social%20media%20profile%20abstract%20concept%2C%20dark%20dramatic%20background%20with%20red%20accents%2C%20digital%20privacy%20theme%2C%20modern%20editorial%20design%2C%20warm%20cinematic%20lighting%2C%20clean%20atmospheric%20composition&width=640&height=480&seq=card-05&orientation=landscape"
                alt="女星小号内容曝光"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                爆料
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                女星小号内容曝光：社交媒体背后的真实人设
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>1天前</span>
                <span>·</span>
                <span>156万阅读</span>
              </div>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20financial%20and%20entertainment%20industry%20concept%2C%20dark%20dramatic%20background%20with%20gold%20and%20red%20tones%2C%20corporate%20intrigue%20atmosphere%2C%20modern%20editorial%20photography%2C%20cinematic%20lighting%20with%20shadows&width=640&height=480&seq=card-06&orientation=landscape"
                alt="娱乐圈资本局大起底"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                深挖
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                娱乐圈资本局大起底：明星投资陷阱背后的真相
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>1天前</span>
                <span>·</span>
                <span>93万阅读</span>
              </div>
            </div>
          </div>

          <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Year%20end%20entertainment%20review%20abstract%20collage%20style%2C%20dark%20dramatic%20background%20with%20red%20and%20gold%20highlights%2C%20retrospective%20media%20design%20aesthetic%2C%20modern%20editorial%20composition%2C%20cinematic%20lighting%20with%20warm%20accents&width=640&height=480&seq=card-07&orientation=landscape"
                alt="年度十大黑料事件盘点"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-secondary-500 text-white text-xs font-label font-semibold whitespace-nowrap">
                回顾
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                年度十大黑料事件盘点：那些让你吃到饱的惊天大瓜
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400 whitespace-nowrap">
                <span>2天前</span>
                <span>·</span>
                <span>320万阅读</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}